import Box from '@mui/material/Box'
import { Person20Regular } from '@/components/Icon'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import PlanUsageCardShell from './PlanUsageCardShell.jsx'
import { PLAN_USAGE } from './planUsageDesignTokens.js'
import { buildHeatColumns } from './PlanUsageActivityHeatmap/planUsageHeatmapData.js'
import { PlanUsageActivityHeatmapGrid } from './PlanUsageActivityHeatmap/PlanUsageActivityHeatmapGrid.jsx'
import { PlanUsageActivityHeatmapLegend } from './PlanUsageActivityHeatmap/PlanUsageActivityHeatmapLegend.jsx'

const HEAT_COLUMNS = buildHeatColumns()

export default function PlanUsageActivityHeatmap() {
  return (
    <PlanUsageCardShell
      sectionAriaLabel="User activity heatmap"
      title="User activity"
      titleIcon={<Person20Regular />}
      intro={getSettingsSectionIntro('plan-activity')}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          width: '100%',
          minWidth: 0,
          bgcolor: PLAN_USAGE.heatMapSurface,
          borderRadius: '10px',
          py: 3,
          gap: 1.25,
          boxSizing: 'border-box',
          transform: 'scale(0.985)',
          transformOrigin: 'top center',
        }}
      >
        <PlanUsageActivityHeatmapGrid columns={HEAT_COLUMNS} />
        <PlanUsageActivityHeatmapLegend />
      </Box>
    </PlanUsageCardShell>
  )
}
